// extracted by mini-css-extract-plugin
export default {"container":"setup-goals__container__FIMcG","goalsRow":"setup-goals__goalsRow__NwUuO","goalContainer":"setup-goals__goalContainer__Dzzvw"};